module.exports = __webpack_public_path__ + "static/media/account_icon.95acec7e.svg";